<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}
</style>
<template>
  <!-- 绑定邮箱模态框 - 开始 -->
  <Modal
    v-model="vis"
    :loading="true"
    :mask-closable="false"
    :title="$t('修改登录密码')"
  >
    <el-form ref="formRef" :model="formData" :rules="rules">
      <div class="tips">{{ $t('旧密码') }}</div>
      <el-form-item prop="oldPassword">
        <el-input
          v-model.trim="formData.oldPassword"
          size="large"
          :placeholder="$t('请输入旧密码')"
        />
      </el-form-item>

      <div class="tips">
        <span>{{ $t('新的登录密码') }}</span>
        <el-tooltip
          effect="dark"
          content="8-20位字符，不能为纯数字"
          placement="bottom"
        >
          <i class="el-icon-warning" style="margin-left:5px"></i>
        </el-tooltip>
      </div>
      <el-form-item prop="password">
        <el-input
          v-model.trim="formData.password"
          type="password"
          size="large"
          show-password
          :placeholder="$t('请输入新密码')"
        />
      </el-form-item>

      <div class="tips">{{ $t('新登录密码确认') }}</div>
      <el-form-item prop="passowrd1">
        <el-input
          v-model.trim="formData.passowrd1"
          type="password"
          size="large"
          show-password
          :placeholder="$t('请再次输入新密码')"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="vis = false">{{ $t('取消') }}</el-button>
      <el-button type="primary" :loading="loading" @click="updateLoginPass">
        {{ $t('确定') }}
      </el-button>
    </template>
  </Modal>
  <!-- 绑定邮箱模态框 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
import { ajax_modifyLoginPassword } from '@/api/personal'

export default {
  name: 'LoginPassModal',
  extends: ModalBase,
  data() {
    const passwordValidator = (_, val, cb) => {
      if (!val) {
        cb(new Error(this.$t('请输入新密码')))
      }
      cb()
    }
    const password1Validator = (_, val, cb) => {
      if (!val) {
        cb(new Error(this.$t('请再次输入新密码')))
      }
      if (val !== this.formData.password) {
        cb(new Error(this.$t('两次密码输入不一致')))
      }
      cb()
    }
    return {
      formData: {
        oldPassword: '',
        password: '',
        passowrd1: ''
      },
      rules: {
        password: [
          {
            trigger: 'blur',
            validator: passwordValidator
          }
        ],
        passowrd1: [
          {
            trigger: 'blur',
            validator: password1Validator
          }
        ],
        oldPassword: [
          {
            required: true,
            message: this.$t('请输入旧密码'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    async updateLoginPass() {
      await this.$refs.formRef.validate()
      // 确认绑定邮箱
      this.loading = true
      try {
        const { passowrd1: _, ...params } = this.formData
        await ajax_modifyLoginPassword(params)
        this.$Message.success({
          content: '登录密码修改成功，请重新登录',
          duration: 1.5,
          onClose: async () => {
            await this.$store.dispatch('signOut', false)
            this.vis = false
            this.loading = false
          }
        })
      } catch {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.tips {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-bottom: 10px;
  .el-icon-sort {
    transform: rotate(90deg);
    cursor: pointer;
  }
}
.code-box {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
</style>
